/**
 * Cart Refresh Hook
 * -----------------
 * Exposes window.refreshShopifyCart() to update the cart drawer
 * and cart count badges from any app or custom script.
 *
 * Usage:
 *   window.refreshShopifyCart()        — update cart and open drawer
 *   window.refreshShopifyCart(false)   — update cart silently (no drawer)
 */
(function () {
  if (window.__cartRefreshHookInstalled) return;
  window.__cartRefreshHookInstalled = true;

  /**
   * Refreshes the cart drawer contents and all cart-count badges,
   * then optionally opens the cart drawer.
   *
   * @param {boolean} openDrawer - Whether to open the cart drawer (default: true)
   */
  function refreshCart(openDrawer) {
    if (typeof openDrawer === "undefined") openDrawer = true;

    var cartDrawer = document.querySelector("cart-drawer[data-section-id]");

    // Gather section IDs the same way the theme does internally
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      }),
    );

    var cartUpdateUrl =
      window.theme && theme.routes && theme.routes.cart_update_url
        ? theme.routes.cart_update_url
        : "/cart/update.js";

    // Open the cart drawer IMMEDIATELY for instant feedback
    if (openDrawer && cartDrawer && typeof cartDrawer.show === "function") {
      cartDrawer.show();
    }

    // POST to /cart/update.js with sections — returns cart JSON WITH rendered section HTML
    fetch(cartUpdateUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        sections: sectionsToBundle,
      }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cartJson) {
        // Publish through the theme's pubsub system — this updates:
        // - All <cart-count> elements (header, drawer, mobile dock)
        // - The <cart-items> / MiniCart inside the cart drawer (using sections HTML)
        if (window.theme && theme.pubsub && theme.pubsub.publish) {
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            cart: cartJson,
          });
        }

        // Also dispatch the DOM event for any other listeners
        document.dispatchEvent(
          new CustomEvent("cart:updated", {
            detail: { cart: cartJson },
          }),
        );
      })
      .catch(function (err) {
        console.warn("[cart-refresh-hook] Could not refresh cart:", err);
      });
  }

  window.refreshShopifyCart = refreshCart;
})();
